// extracted by mini-css-extract-plugin
module.exports = {"header":"MainHeader_header__3jG-X","active":"MainHeader_active__11wpQ"};